import React from 'react'
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes as RouterRoutes,
} from 'react-router-dom'
import AuthorizedRoute from 'components/AuthorizedRoute/AuthorizedRoute'
import { pages } from 'constants/pages'
import Campaigns from 'pages/Campaigns/Campaigns'
import CampaignDetail from 'pages/CampaignDetail/CampaignDetail'
import Connect from 'pages/Connect/Connect'
import Dashboard from 'pages/Dashboard/Dashboard'
import NotFound from 'pages/NotFound/NotFound'
import MainLayout from 'layouts/MainLayout/MainLayout'
import NewCampaign from 'pages/NewCampaign/NewCampaign'
import Subscription from 'pages/Subscription/Subscription'
import Reddit from 'pages/Oauth/Reddit'
import Privacy from 'pages/Privacy/Privacy'
import TermsOfService from 'pages/Privacy/TermsOfService'
import ModernPostScheduling from 'components/PostScheduling/PostScheduling'
import Instagram from 'pages/Oauth/Instagram'
import UserPosts from 'pages/UserPosts/UserPosts'
import TikTok from 'pages/Oauth/TikTok'
import Youtube from 'pages/Oauth/Youtube'
import SubscriptionCallback from 'pages/Subscription/SubscriptionCallback'
import Profile from 'pages/Profile/Profile'
import Trends from 'pages/Trends/Trends'
import ModernTargetAudience from 'pages/TargetAudience/TargetAudience'
import AnalyzeCreators from 'pages/TargetAudience/AnalyzeCreators'
import ModernAnalyzeFollowers from 'pages/TargetAudience/AnalyzeFollowers'
import Automations from 'pages/InstagramAutomation/Automations'
import InstagramAutomation from 'pages/InstagramAutomation/InstagramAutomation'
import YouTubeAutomation from 'pages/InstagramAutomation/YouTubeAutomation'
import CreateAutomation from 'pages/InstagramAutomation/CreateAutomation'
import Popularity from 'pages/Popularity/Popularity'
import SocialCards from 'pages/SocialCards/SocialCards'
import SocialComments from 'pages/SocialComments/SocialComments'
import PostDetails from 'pages/PostDetails/PostDetails'
import FollowersList from 'pages/FollowersList/FollowersList'
import AICampaignChat from 'pages/AICampaignChat/AICampaignChat'
import InteractionAnalyticsPage from 'pages/InteractionAnalytics/InteractionAnalyticsPage'
import AllInteractionsPage from 'pages/InteractionAnalytics/AllInteractionsPage'
import ConnectedAccountsPage from 'pages/Connect/ConnectedAccounts'
import CompetitorDashboard from 'components/Competitor/CompetitorDashboard'
import NewCompetitorCampaign from 'pages/NewCampaign/NewCompetitorCampaign'
import ScrollToTop from 'components/ScrollToTop/ScrollToTop'
import FollowerAnalytics from 'components/FollowerAnalytics/FollowerAnalytics'
import DiscoverContent from 'pages/DiscoverContent/DiscoverContent'
import ListeningTopics from 'pages/ListeningTopics/ListeningTopics'
import SuperFansPage from 'pages/SuperFans/SuperFansPage'
import AdminDashboard from 'pages/Admin/AdminDashboard'
import Analyzer from 'pages/Analyzer/Analyzer'
import PodcastAnalyzer from 'pages/PodcastAnalyzer/PodcastAnalyzer'
import PodcastLanding from 'pages/PodcastLanding/PodcastLanding'
import Analytics from 'pages/Analytics/Analytics'
import Accounts from 'pages/Accounts/Accounts'
import PostsPage from 'pages/Posts/Posts'




function isAppSubdomain(): boolean {
  return window.location.hostname === 'app.nalapod.com' || window.location.hostname === 'localhost'
}

function RootRedirect(): JSX.Element {
  // On app.nalapod.com, redirect to dashboard (triggers auth)
  // On nalapod.com / www.nalapod.com, show landing page
  if (isAppSubdomain()) {
    return <Navigate to={pages.dashboard} />
  }
  return <PodcastLanding />
}

export default function Routes(): JSX.Element {
  return (
    <BrowserRouter>
    <ScrollToTop />
      <RouterRoutes>
        {/* Root: landing page on nalapod.com, redirect on app.nalapod.com */}
        <Route path="/" element={<RootRedirect />} />
        <Route path="/index.html" element={<RootRedirect />} />

        <Route path="/" element={<AuthorizedRoute />}>
          <Route path="/" element={<MainLayout />}>
            <Route path={pages.dashboard} element={<Dashboard />} />
            <Route path={pages.listeningTopics} element={<ListeningTopics />} />
            <Route path={pages.analytics} element={<Analytics />} />
            <Route path={pages.accounts} element={<Accounts />} />
            <Route path={pages.posts} element={<PostsPage />} />
            <Route path={pages.campaigns} element={<Campaigns />} />
            <Route path={pages.campaignDetail} element={<CampaignDetail />} />
            <Route path={pages.newCampaign} element={<AICampaignChat />} />
            <Route path="/campaigns/new/competitor" element={<NewCompetitorCampaign />} />
            <Route path={pages.subscription} element={<Subscription />} />
            <Route
              path={pages.subscription_callback}
              element={<SubscriptionCallback />}
            />
            <Route path={pages.post} element={<ModernPostScheduling />} />
            <Route path={pages.userPosts} element={<UserPosts />} />
            <Route path={pages.oauth.redditCode} element={<Reddit />} />
            <Route path={pages.oauth.instagramCode} element={<Instagram />} />
            <Route path={pages.oauth.tiktokCode} element={<TikTok />} />
            <Route path={pages.oauth.youtubeCode} element={<Youtube />} />
            <Route path={pages.profile} element={<Profile />} />
            <Route path={pages.trends} element={<Trends />} />
            <Route path={pages.target.intro} element={<ModernTargetAudience />} />
            <Route path={pages.target.creators} element={<AnalyzeCreators />} />
            <Route
              path={pages.target.followers}
              element={<ModernAnalyzeFollowers />}
            />
            <Route path="/automations" element={<Automations />}>
              <Route index element={<Navigate to="instagram" replace />} />  {/* Default */}
              <Route path="instagram" element={<InstagramAutomation />} />
              <Route path="youtube" element={<YouTubeAutomation />} />
            </Route>
            <Route path="/automations/create" element={<CreateAutomation />} />
            <Route 
            path="/interactions" 
            element={<AllInteractionsPage />} 
            />
            <Route 
            path={pages.followerAnalytics} 
            element={<FollowerAnalytics />} 
            />

            <Route
            path="/connected-accounts"
            element={<ConnectedAccountsPage />}
            />
            <Route
            path="/campaigns/:campaignId/competitors"
            element={<CompetitorDashboard />}
            />
            <Route
            path={pages.superFans}
            element={<SuperFansPage />}
            />
            <Route path={pages.postdetails} element={<PostDetails />} />
            <Route path={pages.popularity} element={<Popularity />} />
            <Route path={pages.socialcards} element={<SocialCards />} />
            <Route path={pages.socialcomments} element={<SocialComments />} />
            <Route path={pages.discoverContent} element={<DiscoverContent />} />
            <Route path={pages.admin} element={<AdminDashboard />} />
          </Route>
          <Route 
            path="/campaigns/:campaignId/interactions" 
            element={<InteractionAnalyticsPage />} 
          />

          <Route path={pages.connect} element={<Connect />} />
          <Route path={'*'} element={<NotFound />} />
          <Route path={pages.followerslist} element={<FollowersList />} />
        </Route>
        <Route path={pages.privacy} element={<Privacy />} />
        <Route path={pages.terms} element={<TermsOfService />} />
        <Route path="/analyze" element={<Analyzer />} />
        <Route path="/podcast-analyzer" element={<PodcastAnalyzer />} />
        <Route path="/podcasters" element={<PodcastLanding />} />
      </RouterRoutes>
    </BrowserRouter>
  )
}
